<template>
	<div class="keywordFormList">
		<!-- 列表 -->
		<data-list
			ref="datalist"
			:table-style="{ name: 'webclient' }"
			:data="data"
			:columns="column"
		></data-list>
	</div>
</template>

<script>
export default {
	name: 'keywordFormList',
	props: ['value','column'],
	components: {},
	data() {
		return {
			data: [],
		};
	},
	watch: {
		value: {
			handler(val) {
				this.data = val;
			},
			immediate: true,
			deep: true,
		},
	},
};
</script>

<style lang="scss" scoped>
.keywordFormList {
}
</style>
